/* 甘寧傳・第 4 章：益陽（建安二十年，215）
 * 資水由西往東流；南岸是益陽，魯肅的營在東南。上游（西邊）有一處淺瀨（FORD）可以涉水，關羽的銳士在北岸的營裡等著夜渡。 */
export const FORD = [1900, 2260], LUSU = [6000, 3900], GUAN = [1950, 1050], GUAN_HQ = [5600, 950];
export const BANK_S = 2600, LINE_S = 3450; // 南岸邊、過了這條線就算「過瀨」
export default {
  id: 'ganning_yiyang', name: '益陽', W: 8000, H: 5000, seed: 215,
  bases: [LUSU, GUAN],
  rivers: [{ pts: [[-100, 2300], [2500, 2250], [5000, 2350], [8100, 2300]], hw: 230, fords: [[FORD[0], FORD[1], 380]] }],
  roads: [
    { pts: [LUSU, [4500, 3300], [2700, 3150], [FORD[0], 2700]], w: 120 },
    { pts: [[FORD[0], 1850], GUAN, [3800, 900], GUAN_HQ], w: 110 },
  ],
  rocks: [[3300, 2900, 300, 130], [700, 3300, 320, 150], [4000, 1500, 380, 170], [7000, 1600, 380, 170]],
  woods: 0.5,
  sight: 0.6,
  clearings: [[FORD[0], FORD[1], 650], [LUSU[0], LUSU[1], 520], [GUAN[0], GUAN[1], 520], [GUAN_HQ[0], GUAN_HQ[1], 460]],
  grass: [[2500, 2850, 200, 90], [1300, 2850, 200, 90]],
  tents: [{ x: LUSU[0], y: LUSU[1], n: 6, r: 380, chief: true, col: '#b8433a', flag: '魯' }, { x: GUAN[0], y: GUAN[1] - 60, n: 6, r: 380, col: '#3e7b50' }, { x: GUAN_HQ[0], y: GUAN_HQ[1], n: 8, r: 420, chief: true, col: '#3e7b50', flag: '關' }],
};
